import React from "react";

const CompanyAddress = ({
  align = "end",
  company = "New Way Transport Inc.",
  street = "18337 STONY ISLAND AVE",
  region = "LANSING, IL 60438-1540",
}) => {
  return (
    <div className={`col-3 text-${align}`}>
      <strong>{company}</strong>
      <br />
      {street}
      <br />
      {region}
    </div>
  );
};

export default CompanyAddress;
